import { useEffect } from "react";
import SEOHead from "@/components/SEOHead";
import Navbar from "@/components/landing/Navbar";
import InquiryPortal from "@/components/landing/InquiryPortal";
import Footer from "@/components/landing/Footer";
import VisitorTracker from "@/components/VisitorTracker";
import { useT } from "@/i18n/LocaleContext";

export default function InquiryPortalPage() {
  const { t, locale } = useT();
  useEffect(() => {
    const de = locale === "de";
    document.title = de
      ? "Anfrage-Portal · Fertigungsanfrage · Hamm Entwicklung + Produktion GmbH"
      : "Inquiry Portal · Manufacturing Request · Hamm EP GmbH";
    const setMeta = (name, value, attr = "name") => {
      if (!value) return;
      let el = document.head.querySelector(`meta[${attr}="${name}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute(attr, name); document.head.appendChild(el); }
      el.setAttribute("content", value);
    };
    setMeta("description", de
      ? "Fertigungsanfrage stellen: Laserschneiden, Abkanten, Schweißen. DXF, STEP, IGES und PDF sicher hochladen – Angebot meist innerhalb 24 h."
      : "Submit a manufacturing inquiry: laser cutting, bending, welding. Upload DXF, STEP, IGES and PDF drawings – quote usually within 24 h.");
    return () => { document.title = de ? "Hamm Entwicklung + Produktion GmbH" : "Hamm EP GmbH"; };
  }, [locale]);

  return (
    <div className="min-h-screen bg-white text-[var(--ci-grey)]" data-testid="inquiry-portal-page">
      <VisitorTracker />
      <SEOHead path="/anfrage-portal" />
      <Navbar />
      <main style={{ paddingTop: "var(--header-h, 112px)" }}>
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12 pt-16 lg:pt-24 pb-4">
          <h1 className="sr-only" data-testid="inquiry-portal-h1">
            {locale === "de"
              ? "Anfrage-Portal – Fertigungsanfrage an Hamm Entwicklung + Produktion GmbH senden"
              : "Inquiry Portal – Send a manufacturing request to Hamm EP GmbH"}
          </h1>
          <nav aria-label="Breadcrumb" className="font-tech text-[10px] tracking-[0.22em] uppercase text-[var(--ci-grey)]">
            <a href="/" className="hover:text-[var(--ci-turquoise)] transition-colors">{locale === "de" ? "Start" : "Home"}</a>
            <span className="mx-2 text-[var(--ci-grey)]/60">/</span>
            <span className="text-[var(--ci-blue)]">{t("nav.inquiry")}</span>
          </nav>
        </div>
        <InquiryPortal />
      </main>
      <Footer />
    </div>
  );
}
